import { TbCheckbox } from "react-icons/tb";
import PropTypes from "prop-types";

const ApproveIcon = ({
  onClick,
  size,
  sx,
  className,
  title,
  hidden,
  disabled,
}) => {
  return (
    <TbCheckbox
      className={`${className} no-shrink`}
      size={size}
      onClick={onClick}
      style={sx}
      title={title}
      hidden={hidden}
      disabled={disabled}
    />
  );
};

ApproveIcon.defaultProps = {
  size: 30,
  onClick: () => {},
  sx: {},
  className: "",
  title: "Approve",
  hidden: false,
  disabled: false,
};

ApproveIcon.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.number,
  sx: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
};
export default ApproveIcon;
